import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

export const suspendDriver = async (driverId, reason) => {
  const fn = httpsCallable(functions, 'suspendDriver');
  const result = await fn({ driverId, reason });
  return result.data;
};

export const unsuspendDriver = async (driverId) => {
  const fn = httpsCallable(functions, 'unsuspendDriver');
  const result = await fn({ driverId });
  return result.data;
};

export const flagRideForFraud = async (rideId, reason) => {
  const fn = httpsCallable(functions, 'flagRideForFraud');
  const result = await fn({ rideId, reason });
  return result.data;
};

export const emergencyCancelRide = async (rideId, reason) => {
  const fn = httpsCallable(functions, 'emergencyCancelRide');
  const result = await fn({ rideId, reason });
  return result.data;
};

export const listOngoingRides = async (limit = 50) => {
  const fn = httpsCallable(functions, 'listOngoingRides');
  const result = await fn({ limit });
  return result.data.rides;
};

export const getAnalytics = async (days = 7) => {
  const fn = httpsCallable(functions, 'getAnalytics');
  const result = await fn({ days });
  return result.data;
};
